<template>
  <section id="video-center" class="match-video-section">
    <div class="video-title">
      <img :src="matchVideoSectionData.titleImage" alt="视频中心" />
    </div>

    <div class="video-grid">
      <div v-for="video in matchVideoSectionData.videos" :key="video.id" class="video-card" @click="openVideo(video)">
        <div class="video-cover">
          <img class="video-cover-image" :src="video.cover" :alt="video.title" />
          <img class="video-card-frame" :src="matchVideoSectionData.cardFrameImage" alt="" />
          <img class="video-play-icon" :src="matchVideoSectionData.playIcon" alt="播放" />
        </div>

        <div class="video-name">{{ video.title }}</div>
      </div>
    </div>

    <van-overlay
      class="video-preview-mask"
      :show="currentVideo !== null"
      :duration="0"
      :z-index="1000"
      @click="closeVideo"
    >
      <video
        v-if="currentVideo"
        ref="videoPlayer"
        class="video-preview"
        :src="currentVideo.videoUrl"
        autoplay
        controls
        playsinline
        @click.stop
      ></video>
    </van-overlay>
  </section>
</template>

<script>
import { matchVideoSectionData } from '@/data/match/matchVideo'

export default {
  name: 'MatchVideoCenter',
  data() {
    return { matchVideoSectionData, currentVideo: null }
  },
  methods: {
    openVideo(video) {
      this.currentVideo = video
      this.$nextTick(() => {
        if (this.$refs.videoPlayer) this.$refs.videoPlayer.play().catch(() => undefined)
      })
    },
    closeVideo() {
      this.currentVideo = null
    },
  },
}
</script>

<style scoped lang="scss">
.match-video-section {
  min-height: 5.625rem;
  padding-top: 0.208333rem;
  background: #f1f2f4 url('@/assets/image/match/pc/match/video-section-bg.png') center top no-repeat;
  background-size: cover;
  box-sizing: border-box;

  .video-title {
    width: 6.880208rem;
    height: 0.864583rem;
    margin: 0 auto;

    img {
      display: block;
      width: 6.880208rem;
      height: 0.864583rem;
      object-fit: contain;
    }
  }

  .video-grid {
    display: grid;
    grid-template-columns: repeat(3, 2.34375rem);
    column-gap: 0.135417rem;
    row-gap: 0.3125rem;
    width: 7.302083rem;
    margin: 0.421875rem auto 0;
  }

  .video-card {
    width: 2.34375rem;
    cursor: pointer;

    .video-cover {
      position: relative;
      width: 2.34375rem;
      height: 1.317708rem;

      .video-cover-image,
      .video-card-frame {
        position: absolute;
        display: block;
      }

      .video-cover-image {
        top: 1.9763%;
        left: 1.3333%;
        width: 97.5556%;
        height: 95.4545%;
        object-fit: cover;
        object-position: center;
        z-index: 1;
      }

      .video-card-frame {
        inset: 0;
        width: 2.34375rem;
        height: 1.317708rem;
        pointer-events: none;
        z-index: 2;
      }

      .video-play-icon {
        position: absolute;
        top: 0.494792rem;
        left: 1.005208rem;
        display: block;
        width: 0.333333rem;
        height: 0.333333rem;
        pointer-events: none;
        z-index: 3;
      }
    }

    .video-name {
      width: 2.34375rem;
      height: 0.151042rem;
      margin-top: 0.208333rem;
      overflow: hidden;
      color: #000000;
      font-size: 0.125rem;
      font-weight: bold;
      line-height: 0.151042rem;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .video-preview-mask {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;

    .video-preview {
      display: block;
      width: auto;
      height: 3.125rem;
      max-width: none;
      background: #000000;
    }
  }
}

@media (max-width: 750px) {
  .match-video-section {
    min-height: auto;
    padding: 8vw 0 0vw;
    background: transparent;

    .video-title {
      width: 90%;
      height: auto;

      img {
        width: 100%;
        height: auto;
      }
    }

    .video-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      column-gap: 3vw;
      row-gap: 5vw;
      width: 95%;
      margin: 6vw auto 0;
    }

    .video-card {
      width: 100%;

      .video-cover {
        width: 100%;
        height: auto;
        aspect-ratio: 900 / 506;
      }

      .video-cover .video-card-frame {
        position: absolute;
        inset: 0;
        display: block;
      }

      .video-cover .video-card-frame {
        width: 100%;
        height: 100%;
      }

      .video-cover .video-play-icon {
        top: 50%;
        left: 50%;
        width: 12vw;
        height: 12vw;
        transform: translate(-50%, -50%);
      }

      .video-name {
        width: 100%;
        height: auto;
        margin-top: 3vw;
        font-size: 3vw;
        line-height: 4vw;
        white-space: normal;
      }
    }

    .video-preview-mask {
      padding: 4vw;
      box-sizing: border-box;

      .video-preview {
        width: 92vw;
        height: auto;
        max-width: 92vw;
      }
    }
  }
}
</style>
